import { render, staticRenderFns } from "./ViewEditGroup.vue?vue&type=template&id=ade4e990&"
import script from "./ViewEditGroup.vue?vue&type=script&lang=js&"
export * from "./ViewEditGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports